import React, { useState, useRef, useEffect } from 'react';
import { useLanguageStore, Language } from '../store/languageStore';
import { ChevronDown } from 'lucide-react';
import translations from '../translations';

const flags: Record<Language, string> = {
  en: '🇺🇸',
  ru: '🇷🇺',
  uz: '🇺🇿'
};

export function LanguageSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const { language, setLanguage } = useLanguageStore();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const t = translations[language];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const languages: Language[] = ['en', 'ru', 'uz'];

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-border transition-colors"
      >
        <div className="flex items-center gap-2">
          <span className="text-xl">{flags[language]}</span>
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{t.languages[language]}</span>
        </div>
        <ChevronDown className={`h-4 w-4 text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white dark:bg-dark-card rounded-lg shadow-lg border border-gray-200 dark:border-dark-border py-1 z-50">
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => {
                setLanguage(lang);
                setIsOpen(false);
              }}
              className={`w-full flex items-center justify-between gap-3 px-4 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-dark-border transition-colors ${
                language === lang ? 'bg-gray-50 dark:bg-dark-border' : ''
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-xl">{flags[lang]}</span>
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {t.languages[lang]}
                </span>
              </div>
              {language === lang && (
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}